import React from "react";
import {Grid, Card, Typography} from "@mui/material";
import {Link} from "react-router";

interface BookingConfirmationProps {
  bookingNumber?: string;
  instantApproval: boolean;
  brokered: boolean;
}

const blueCardSx = {
  backgroundColor: 'rgba(216, 248, 255, 1)',
  marginTop: '1.5em',
} as const;

const BookingConfirmation = (props: BookingConfirmationProps) => {
  const {bookingNumber, instantApproval, brokered} = props;

  const instantApprovalMessage = "This order has been approved and your payment is processing. Please check the My Bookings page for details about your booking.";
  const reserveSpaceMessage = "This order has been submitted for approval. Please check the My Bookings page for the status of this order. You will not be charged until the order is approved"

  const shouldShowBookingNumber = (brokered || instantApproval) && bookingNumber;

  return <Grid item>
    <Grid className="ss-byb-content">
      <Typography variant={'h5'} color={'textPrimary'}>Thanks for your order</Typography>
      <Card className="ss-byb-card" sx={blueCardSx}>
        <Typography variant="h6">{ shouldShowBookingNumber ? `Booking #${bookingNumber}`: 'Confirmation' }</Typography>
        <Typography variant="body2">{ instantApproval ? instantApprovalMessage : reserveSpaceMessage }</Typography>
        <br/>
        <Link to="/bookings" style={{textDecoration: 'none'}}>
          <Typography variant='body2' color={'secondary'}>VIEW MY BOOKINGS</Typography>
        </Link>
      </Card>
    </Grid>
  </Grid>
}

export default BookingConfirmation;
